// src/layouts/DashboardLayout.jsx

import { useState } from "react";
import { Outlet } from "react-router-dom";  // ✅ Import Outlet
import SideBarCustomer from "./SidebarCustomer";
import FooterNav from "../../components/FooterNav";
// import FloatingNav from "../../components/FloatingNav";


const CustomerLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen">
      <SideBarCustomer isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 p-4 h-screen overflow-y-auto">
        <div className="flex justify-between items-center mb-4 md:hidden">
          <div className="font-bold text-lg">Stellaris</div>
          <button onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
        </div>

        {/* ✅ Nested routes will render here */}
        <Outlet />

        <FooterNav/> 
        {/* <FloatingNav /> */}
      </div>
    </div>
  );
};

export default CustomerLayout;
